(function(){
    'use strict';
    angular.module('app').controller('FleetsController', FleetsController);

    FleetsController.$inject = ['$scope', 'FleetsTableService'];

    function FleetsController($scope, FleetsTableService) {

        const vm = this;

        init();

        function init() {
            const paginationData = {
                size: 5,
                page: 0,
                sort: 'id'
            };
            getFleets(paginationData);

        }

        function getFleets() {
            vm.fleetsTableData = new FleetsTableService().tableData;
        }

    }
})();


// WEBPACK FOOTER //
// ./js/controllers/FleetsController.js